import { useCallback, useMemo } from 'react';
import { post } from 'libs/fetch';

export const useSchedule = () => {
  const createSchedule = useCallback(async () => {
    const response = await post('api/v1/admin/sales_forces/schedules', {})
    if (response.ok) {
      return { result: true }
    }

    return { result: false }
  }, []);

  return useMemo(() => ({ createSchedule }),[ createSchedule ])
}
